export default "__VITE_ASSET__LuCo_Qzu__"